import React from 'react';
import { TimePicker } from 'antd';
import type { TimePickerProps } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

type CustomTimePickerProps = {
  timeZone?: string;
  timeFormat?: string;
  popupClassName?: string;
} & Omit<TimePickerProps, 'format' | 'renderExtraFooter'>;

const CustomTimePicker: React.FC<CustomTimePickerProps> = ({
  value,
  onChange,
  timeZone,
  className = 'custom-picker',
  showNow = false,
  timeFormat = 'h:mm a',
  use12Hours = true,
  disabled = false,
  size = 'middle',
  placeholder,
  suffixIcon,
  popupClassName = 'tz-timepicker-dropdown',
  ...rest
}) => {
  const defaultFooter = () => {
    const tz = timeZone || dayjs.tz.guess();
    const nowInTZ = dayjs().tz(tz);
    return (
      <a
        style={{
          display: 'block',
          textAlign: 'start',
          padding: '4px 0 0 12px',
        }}
        onClick={() => onChange?.(nowInTZ, nowInTZ.format(timeFormat))}
      >
        Now
      </a>
    );
  };

  return (
    <TimePicker
      {...rest}
      value={value}
      onChange={onChange}
      className={className}
      popupClassName={popupClassName}
      format={timeFormat}
      use12Hours={use12Hours}
      suffixIcon={suffixIcon}
      disabled={disabled}
      size={size}
      placeholder={placeholder}
      showNow={showNow}
      renderExtraFooter={defaultFooter}
    />
  );
};

export default CustomTimePicker;
